import { Outlet } from 'react-router-dom';
import { useState } from 'react';
import AppHeader from '../components/common/AppHeader';
import Sidebar from '../components/common/Sidebar';

export default function AdminLayout() {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50">
      <AppHeader />
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)} 
      />
      <main className={`
        transition-all duration-300
        pt-16
        ${isSidebarCollapsed ? 'lg:pl-16' : 'lg:pl-64'}
        pb-16 lg:pb-8
      `}>
        <div className="container mx-auto px-4 py-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}